import { render, staticRenderFns } from "./AuditLogPanel.vue?vue&type=template&id=3c22bbd3&scoped=true&"
import script from "./AuditLogPanel.vue?vue&type=script&lang=ts&"
export * from "./AuditLogPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AuditLogPanel.vue?vue&type=style&index=0&id=3c22bbd3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22bbd3",
  null
  
)

export default component.exports